import {
  LuBadgeDollarSign,
  LuBuilding2,
  LuLayers3,
  LuMapPinned,
  LuPencilRuler,
} from 'react-icons/lu';

export const SurveyIcon = () => (
  <span className="partners__icon-combo" aria-hidden="true">
    <LuMapPinned className="partners__icon-svg partners__icon-svg--base" />
    <LuPencilRuler className="partners__icon-svg partners__icon-svg--overlay" />
  </span>
);

export const ArchitectureIcon = () => (
  <LuBuilding2 className="partners__icon-svg" aria-hidden="true" />
);

export const BimIcon = () => <LuLayers3 className="partners__icon-svg" aria-hidden="true" />;

export const DevelopmentIcon = () => (
  <span className="partners__icon-combo" aria-hidden="true">
    <LuBuilding2 className="partners__icon-svg partners__icon-svg--base" />
    <LuBadgeDollarSign className="partners__icon-svg partners__icon-svg--overlay" />
  </span>
);
